module.exports = __webpack_public_path__ + "static/media/luong-gio-coanda-active.89ea35a8.svg";